import { useState, createRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import Avatar from '../components/Avatar';
import Button from '../components/Button';
import Loader from '../components/Loader';
import { Modal, ModalExit, ModalName, ModalPart } from '../components/Modal';
import { useToast } from '../components/Toast';
import { VIEWER } from '../utilities/queries';
import { UPDATE_VIEWER_AVATAR } from '../utilities/mutations';

const EditAvatarModal = () => {
  const navigate = useNavigate();
  const input = createRef();
  const toast = useToast();
  const { loading, data } = useQuery(VIEWER);
  const [updateViewerAvatar] = useMutation(UPDATE_VIEWER_AVATAR);
  const [isUploading, setIsUploading] = useState(false);

  const close = () => !isUploading && !loading && navigate('/settings/main');

  return (
    <Modal onClose={() => close()}>
      {loading ? (
        <ModalPart>
          <Loader />
        </ModalPart>
      ) : (
        <>
          <ModalExit disabled={isUploading} />
          <ModalName>Edit avatar</ModalName>
          <ModalPart>
            <Avatar
              src={data.viewer.avatarUrl}
              alt={`${data.viewer.name} avatar`}
            />
          </ModalPart>
          <ModalPart>
            {data.viewer.avatarUrl && (
              <Button
                disabled={isUploading}
                onClick={async () => {
                  setIsUploading(true);
                  try {
                    await updateViewerAvatar({
                      variables: {
                        avatar: null,
                      },
                    });
                    toast({ children: 'Avatar removed' });
                  } catch (error) {
                    toast({ children: error.message });

                    return;
                  }
                  setIsUploading(false);

                  close();
                }}
                isExtended
              >
                Remove
              </Button>
            )}
            <Button
              data-autofocus
              disabled={isUploading}
              onClick={() => input.current.click()}
              isExtended
            >
              Upload
            </Button>
            <input
              ref={input}
              type="file"
              style={{ display: 'none' }}
              accept=".png, .gif, .jpg, .jpeg"
              onChange={(e) => {
                const file = e.currentTarget.files[0];
                const reader = new FileReader();

                reader.onload = async function (event) {
                  setIsUploading(true);
                  await updateViewerAvatar({
                    variables: { avatar: event.target.result },
                  });
                  setIsUploading(false);
                  toast({ children: 'Avatar updated' });
                  close();
                };
                reader.readAsDataURL(file);
              }}
            />
          </ModalPart>
        </>
      )}
    </Modal>
  );
};

export default EditAvatarModal;
